import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'
import { colors } from 'react-select/src/theme'

export const Item = styled.article<any>`
  width: 100%;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 30vh;
  background: var(--gradient);
  @media ${breakpoint.desktop} {
    --text: ${(props) => (props.light ? 'white' : 'black')};
    flex-direction: row;
    height: ${(props) => (props.full ? 'calc(100vh - 108px)' : '20vw')} !important;
    min-height: var(--component-height, 50rem);
    ${(props) =>
      props.light &&
      css`
        --outline: var(--text);
      `}
    ${(props) =>
      props.fixedCover &&
      css`
        background: url('${props.fixedCover}?height=${1200}&auto=webp&format=pjpg&quality=75')
          no-repeat scroll center center;
        background-size: cover;
      `}
  }
  ${(props) =>
    props.cover &&
    css`
      @media ${breakpoint.desktop} {
        background: url('${props.cover}?height=${1200}&auto=webp&format=pjpg&quality=75')
          no-repeat scroll center center;
        background-size: ${props.center ? 'contain' : 'cover'};
      }
    `}
  & {
    color: var(--text);
  }
  ${(props) =>
    props.fixedCover &&
    css`
      --text: ${props.light ? 'white' : 'black'};
      background: url(${props.fixedCover}) no-repeat scroll center center;
      background-size: cover;
    `}
  h2 {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.3;
    @media ${breakpoint.desktop} {
      font-size: ${(props) => (props.full ? '72px' : '36px')};
      line-height: ${(props) => (props.full ? '1' : '48px')};
    }
  }
  p {
    margin: 20px 0;
    font-size: 18px;
    line-height: 26px;
    @media ${breakpoint.desktop} {
      font-size: ${(props) => (props.variant === 'large' ? '18px' : '16px')};
      ${(props) =>
        props.full &&
        css`
          font-size: 40px;
          line-height: 54px;
        `};
    }
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    position: absolute;

    ${(props) => props.videoAboveContentOnMobile && css`
      @media ${breakpoint.desktop_down} {
        position: relative;
      }
    `}
  }
  img {
    object-fit: cover;
    @media ${breakpoint.desktop} {
      max-height: 525px;
    }
    object-position: center center;
  }

  ${(props) =>
    props.overlay &&
    css`
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
        position: absolute;
        background: rgb(0, 0, 0);
        background: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.85) 20%,
          rgba(0, 0, 0, 0) 80%
        );
      }
    `}
  @media ${breakpoint.desktop} {
    ${(props) =>
      props.overlay &&
      css`
        &:before {
          content: '';
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 1;
          position: absolute;
          background: rgb(0, 0, 0);
          background: linear-gradient(
            ${props.left ? 'to right' : 'to left'},
            rgba(0, 0, 0, 0.85) 20%,
            rgba(0, 0, 0, 0) 80%
          );
        }
      `}
  }
`

export const Content = styled.div<any>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  @media ${breakpoint.desktop} {
    width: ${(props) => (props.variant === 'small' ? '350px' : '34%')};
    padding: 0;
    ${(props) =>
      props.large_title &&
      css`
        h2 {
          font-size: 64px;
          line-height: 98px;
        }
      `}
  }
  flex-direction: column;
  opacity: 0.999 !important;
  height: 100%;
  max-width: 55rem;
  ${(props) =>
    props.light &&
    css`
      color: white;
    `};
  ${(props) =>
    props.center &&
    css`
      align-items: center;
      text-align: center;
      @media ${breakpoint.desktop} {
        width: 100%;
        max-width: 100%;
      }
    `}
`

export const Container = styled.div<any>`
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 2;
  left: ${(props) => (props.variant === 'large' ? 0 : `calc(50% - 720px)`)};
  display: flex;
  justify-content: flex-${(props) => (props.left ? `start` : `end`)};
  padding: ${(props) => (props.video ? `10rem` : `2.5rem`)} 1.5rem 2.5rem;
  flex-direction: column;
  @media ${breakpoint.desktop} {
    flex-direction: row;
    padding: 0;
    max-width: 1120px;
    margin: 0 auto;
  }
  ${(props) =>
    props.static &&
    css`
      max-width: 1120px;
      margin: 0 auto;
      min-height: 660px;
      padding: 0 1.5rem 4rem;
      justify-content: flex-end;
      @media ${breakpoint.desktop} {
        min-height: 0;
        padding: 0;
        justify-content: flex-start;
        ${!props.left &&
        css`
          justify-content: flex-end;
        `}
      }
    `}
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
  ${(props) =>
    props.leftDTopM &&
    css`
      @media ${breakpoint.tablet_down} {
        order: 1;
        background-color: var(--black);
      }
  `}
`

export const Splash = styled.div<any>`
  background: none no-repeat scroll center center;
  background-size: cover;
  height: ${(props) => props.hasTitle ? 350 : 127}px;
  @media ${breakpoint.desktop} {
    height: ${(props) => props.height || 375}px;
  }
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 24px 48px;
  font-size: 14px;
  line-height: 1.3;
  ${(props) =>
    props.background &&
    css`
      background-image: url('${props.background}?width=${1440}&auto=webp&format=pjpg&quality=75');
    `}
  & > span {
    display: none;
    @media ${breakpoint.desktop} {
      display: inherit;
    }
  }
`

export const TitleOver = styled.div<any>`
  h1 {
    color: white;
  }
  max-height: 21.875rem;
  @media screen and ${breakpoint.mobile} {
    height: auto;
    background: rgb(0,0,0);
    padding: 1rem;
    margin-bottom: 0;
  }
  @media screen and ${breakpoint.tablet} {
    background: linear-gradient(
            to right,
            rgba(0,0,0,0.85) 0%,
            rgba(0,0,0,0) 70%
    );
    position: absolute;
    width: 100vw;
    height: 100%;
    padding: 0 24px;

    .container {
      max-width: 1151px;
      margin: 0 auto;
      height: 100%;
      max-height: 21.875rem;
      display: flex;
      align-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      h1 {
        font-size: 2.375rem;
        font-weight: 100;
        ${(props) => props.locale && props.locale === 'fr' && css`
          font-size: 2.5rem;
        `}
        line-height: .92;
        position: relative;
        z-index: 10;
      }
    }
  }
  
  @media screen and ${breakpoint.desktop} {
    height: 21.875rem;
  }
`

export const Image = styled.div<any>`
  background: url('${(props) => props.bg}?height=338&auto=webp&format=pjpg&quality=75')
    no-repeat scroll center center;
  background-size: cover;
  width: calc(100% - (${(props) => props.margin || '1.5rem'} * 2));
  margin: ${(props) => props.margin || '1.5rem'};
  max-height: 320px;
  min-height: 160px;
  @media ${breakpoint.desktop} {
    background-image: url('${(props) => props.bg}?height=990&auto=webp&format=pjpg&quality=75');
    background-position: ${(props) => (props.left ? 'right' : 'left')} center;
    height: 50vw;
    display: none;
  }
`
